module.exports = __webpack_public_path__ + "img/IMG_4679.4d59293a.jpg";